import React from 'react'
import { ThemeColor } from 'theme/colors'
import styled, { useTheme } from 'styled-components'

interface ProfileImageProps {
  color?: ThemeColor
  bgColor?: ThemeColor
}

const StyledSvg = styled.svg`
  width: 100%;
  height: auto;
`

export const ProfileImageSquare = ({
  color,
  $bgColor,
}: Required<{ color?: string; $bgColor: string }>) => {
  const theme = useTheme()
  return (
    <StyledSvg
      viewBox="0 0 400 400"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="400" height="400" fill={theme.color[$bgColor]} />
      <path
        d="M200 82C161.325 82 130 113.325 130 152C130 190.675 161.325 222 200 222C238.675 222 270 190.675 270 152C270 113.325 238.675 82 200 82ZM200 239.5C153.275 239.5 60 262.95 60 309.5V362H340V309.5C340 284.773 313.681 266.564 282 254.925C254.04 244.654 221.905 239.5 200 239.5Z"
        fill={theme.color[color]}
      />
    </StyledSvg>
  )
}

export const ProfileImageRound = ({
  color,
  $bgColor,
}: Required<{ color?: string; $bgColor: string }>) => {
  const theme = useTheme()
  return (
    <StyledSvg
      viewBox="0 0 400 400"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="400" height="400" fill={theme.color[$bgColor]} />
      <circle cx="199.5" cy="146.5" r="72.5" fill={theme.color[color]} />
      <path
        d="M334 296.054C334 330.818 268.036 372 199 372C129.964 372 64 330.818 64 296.054C64 261.29 129.964 233 199 233C268.036 233 334 261.29 334 296.054Z"
        fill={theme.color[color]}
      />
    </StyledSvg>
  )
}

export const ProfileImage = ({
  color = 'white',
  bgColor = 'grey05',
  isRound = true,
  ...props
}: ProfileImageProps & { isRound?: boolean }) => {
  if (isRound) {
    return <ProfileImageRound color={color} $bgColor={bgColor} {...props} />
  }
  return <ProfileImageSquare color={color} $bgColor={bgColor} {...props} />
}
